import { FinalizePackageResponse, Platform } from "redmond";
import { finalizeFlightLodging } from "../../../../../api/v0/itinerary-review/finalizeFlightLodging";
import { PackagesMachineContext } from "../../types";

export const finalizePackageService = (
  context: PackagesMachineContext
): Promise<{ finalizePackageResponse: FinalizePackageResponse }> =>
  new Promise((resolve, reject) => {
    finalizeFlightLodging({
      opaqueQuoteRequest: context.opaqueLodgingRequest || "",
      opaquePackageToken: { value: context.opaqueFlightRequest || "" },
      platform:
        context.platform === "desktop" ? Platform.Desktop : Platform.Mobile,
    })
      .then((finalizePackageResponse) => {
        resolve({ finalizePackageResponse });
      })
      .catch((e) => reject(e));
  });
